import { NgModule } from '@angular/core';
import { SmartEditCoreModule } from './core';

@NgModule({
  imports: [SmartEditCoreModule],
})
export class SpartacusSmarteditModule {}
